// extracted by mini-css-extract-plugin
export default {"language":"LanguageSelect_language__7oDFm","left":"LanguageSelect_left__rmroA","isChecked":"LanguageSelect_isChecked__EDf5L","flag":"LanguageSelect_flag__TeEVz"};